import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { TaskCategoryListItemResource } from 'dy-frontend-http-repository/lib/modules/TaskCategory/resources';
import domain from './domain';
import { resetTaskCategories } from './events';

export const $taskCategories = domain
    .createStore<CollectionResource<TaskCategoryListItemResource, {}> | null>(null)
    .reset(resetTaskCategories);
